import { render } from "./crvCooperationLogo.vue?vue&type=template&id=dd9ed5aa"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__